import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hotel } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import apiClient from '../services/apiConfig';
import { useAuth } from '../context/AuthContext';

const NewLoginPage: React.FC = () => {
  const [email, setEmail] = useState('admin@chiavari.com');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setAuthToken } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiClient.post('/login', { email, password });

      if (response.data.success) {
        const token = response.data.data.token;
        localStorage.setItem('authToken', token);
        setAuthToken(token);
        navigate('/home');
      } else {
        setError('Credenciales inválidas');
      }
    } catch (err) {
      setError('Error al iniciar sesión. Verifica tus credenciales.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-blue-600 text-white rounded-lg mb-4">
            <Hotel size={28} />
          </div>
          <h1 className="text-2xl font-semibold text-slate-900">Hotel Chiavari</h1>
          <p className="text-sm text-slate-600 mt-1">Panel de Administración</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@chiavari.com"
            required
          />

          <Input
            label="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          <Button
            type="submit"
            className="w-full"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>San Bernardo del Tuyú</p>
        </div>
      </Card>
    </div>
  );
};

export default NewLoginPage;
